<template>
  <div class="layout" :class="id" :id="id && id + '-layout'">
    <div class="layout_header">
      <div
        name="header"
        class="flex wrap align-center layout_subheader h-scroll"
      >
        <slot name="header"></slot>
      </div>
    </div>
    <div class="flex column layout_content">
      <slot name="content"></slot>
    </div>
    <!-- @mouseover="showbottom = true"
      @mouseleave="showbottom = false" :style="showbottom ? 'bottom: 16px' : 'bottom:0px'"-->
    <div :class="`align-${alignfoot || 'center'}`" class="flex between layout_footer" :style="`${relative ? 'position: relative; ' : alignfoot && (alignfoot == 'end' && 'right: 0; ' || alignfoot == 'start' && 'left: 0; ')}`">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showbottom: false,
    };
  },
  name: "layout",
  props: ["header", "content", "footer", "id", "description", "relative", "alignfoot"], // all element and/or component objects
};
</script>
<style>
.layout {
  display: flex;
  flex-flow: column;
  align-items: stretch;
  max-height: 100%;
  justify-content: flex-start;
  overflow: hidden;
  height: 100%;
}
.layout_header {
  position: relative;
  display: flex;
  align-items: stretch;
  z-index: 1;
}
.layout_subheader {
  overflow-x: scroll;
}
.layout_content {
  overflow-y: scroll;
  /* max-height: 100%;
  height: 100%; */
}
.layout_footer {
  /* position: absolute; */
  bottom: 0;
  /* width: 61.8%; */
  /* align-self: center; */
  align-items: center;
}
</style>